var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeader1Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.049,
    height: 34.438,
    viewBox: "0 0 35.049 34.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8867",
    "data-name": "Group 8867",
    transform: "translate(-1578 -942.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_8878",
    "data-name": "Path 8878",
    transform: "translate(1584.49 942.938)",
    fill: "#274c6b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.1258602142334 30.69034194946289 L 6.442344188690186 29.2923412322998 L 6.395064353942871 29.287841796875 L 6.347564220428467 29.287841796875 C 2.445434331893921 29.287841796875 -0.7291857600212097 26.11322021484375 -0.7291857600212097 22.21108055114746 L -0.7291857600212097 22.08709144592285 L -0.759465754032135 21.96685028076172 L -4.187699794769287 8.355224609375 C -3.559003829956055 7.681040287017822 -2.154478788375854 6.222898006439209 -0.4755657613277435 4.782930850982666 C 2.3686842918396 2.343471050262451 4.791854381561279 1.000001072883606 6.347564220428467 1.000001072883606 L 20.48189353942871 1.000001072883606 C 24.38403511047363 1.000001072883606 27.55865478515625 4.174621105194092 27.55865478515625 8.076761245727539 L 27.55865478515625 22.21108055114746 C 27.55865478515625 23.76212120056152 26.42905426025391 25.73546028137207 24.2919750213623 27.91775131225586 C 23.00195503234863 29.23506355285645 21.69315719604492 30.26321029663086 21.1258602142334 30.69034194946289 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.347564697265625 2.000001907348633 C 5.734914779663086 2.000001907348633 3.908674240112305 2.343770980834961 0.1917343139648438 5.528030395507812 C -1.182092666625977 6.704971313476562 -2.370597839355469 7.897321701049805 -3.083976745605469 8.643077850341797 L 0.2708148956298828 21.96309089660645 L 0.2708148956298828 22.21108245849609 C 0.2708148956298828 25.56182098388672 2.996833801269531 28.287841796875 6.347564697265625 28.287841796875 L 6.442554473876953 28.287841796875 L 20.82974052429199 29.65762329101562 C 21.46533393859863 29.16303634643555 22.54036331176758 28.27987098693848 23.59765434265137 27.19748115539551 C 25.5070743560791 25.24272155761719 26.55864334106445 23.47185134887695 26.55864334106445 22.21108245849609 L 26.55864334106445 8.076761245727539 C 26.55864334106445 4.726020812988281 23.8326244354248 2.000001907348633 20.48189353942871 2.000001907348633 L 6.347564697265625 2.000001907348633 M 6.347564697265625 1.9073486328125e-06 L 20.48189353942871 1.9073486328125e-06 C 24.94256401062012 1.9073486328125e-06 28.55864334106445 3.616090774536133 28.55864334106445 8.076761245727539 L 28.55864334106445 22.21108245849609 C 28.55864334106445 26.67175102233887 21.41129493713379 31.7220401763916 21.41129493713379 31.7220401763916 L 6.347564697265625 30.287841796875 C 1.886894226074219 30.287841796875 -1.729185104370117 26.67175102233887 -1.729185104370117 22.21108245849609 L -5.289066314697266 8.076761245727539 C -5.289066314697266 8.076761245727539 1.886894226074219 1.9073486328125e-06 6.347564697265625 1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_8879",
    "data-name": "Path 8879",
    transform: "translate(1578 945.789)",
    fill: "#274c6b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.16379737854004 30.58699798583984 L 8.423197746276855 30.58699798583984 C 4.330028057098389 30.58699798583984 0.9999980330467224 27.25696754455566 0.9999980330467224 23.16379737854004 L 0.9999980330467224 8.423197746276855 C 0.9999980330467224 4.330028057098389 4.330028057098389 0.9999980330467224 8.423197746276855 0.9999980330467224 L 23.16379737854004 0.9999980330467224 C 27.25696754455566 0.9999980330467224 30.58699798583984 4.330028057098389 30.58699798583984 8.423197746276855 L 30.58699798583984 23.16379737854004 C 30.58699798583984 27.25696754455566 27.25696754455566 30.58699798583984 23.16379737854004 30.58699798583984 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.423198699951172 1.999998092651367 C 4.881437301635742 1.999998092651367 1.999998092651367 4.881437301635742 1.999998092651367 8.423198699951172 L 1.999998092651367 23.16379928588867 C 1.999998092651367 26.70555877685547 4.881437301635742 29.58699798583984 8.423198699951172 29.58699798583984 L 23.16379928588867 29.58699798583984 C 26.70555877685547 29.58699798583984 29.58699798583984 26.70555877685547 29.58699798583984 23.16379928588867 L 29.58699798583984 8.423198699951172 C 29.58699798583984 4.881437301635742 26.70555877685547 1.999998092651367 23.16379928588867 1.999998092651367 L 8.423198699951172 1.999998092651367 M 8.423198699951172 -1.9073486328125e-06 L 23.16379928588867 -1.9073486328125e-06 C 27.81579780578613 -1.9073486328125e-06 31.58699798583984 3.771198272705078 31.58699798583984 8.423198699951172 L 31.58699798583984 23.16379928588867 C 31.58699798583984 27.81579780578613 27.81579780578613 31.58699798583984 23.16379928588867 31.58699798583984 L 8.423198699951172 31.58699798583984 C 3.771198272705078 31.58699798583984 -1.9073486328125e-06 27.81579780578613 -1.9073486328125e-06 23.16379928588867 L -1.9073486328125e-06 8.423198699951172 C -1.9073486328125e-06 3.771198272705078 3.771198272705078 -1.9073486328125e-06 8.423198699951172 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4350",
    "data-name": "Rectangle 4350",
    transform: "translate(1583.615 952.107)",
    fill: "#274c6b",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.058,
    height: 6.317,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 19.058,
    height: 4.317,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4351",
    "data-name": "Rectangle 4351",
    transform: "translate(1583.615 961.934)",
    fill: "#274c6b",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.548,
    height: 2.808,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 15.548,
    height: 0.808,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4356",
    "data-name": "Rectangle 4356",
    transform: "translate(1601.866 961.934)",
    fill: "#274c6b",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.808,
    height: 2.808,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 0.808,
    height: 0.808,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4352",
    "data-name": "Rectangle 4352",
    transform: "translate(1583.615 965.444)",
    fill: "#274c6b",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.548,
    height: 2.808,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 15.548,
    height: 0.808,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4355",
    "data-name": "Rectangle 4355",
    transform: "translate(1601.866 965.444)",
    fill: "#274c6b",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.808,
    height: 2.808,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 0.808,
    height: 0.808,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4353",
    "data-name": "Rectangle 4353",
    transform: "translate(1588.529 968.953)",
    fill: "#274c6b",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.635,
    height: 2.808,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 10.635,
    height: 0.808,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4354",
    "data-name": "Rectangle 4354",
    transform: "translate(1601.866 968.953)",
    fill: "#274c6b",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.808,
    height: 2.808,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 0.808,
    height: 0.808,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader1Icon);
export default __webpack_public_path__ + "static/media/header1Icon.0472883aa5c5e9fdb97a9aa43585b1b0.svg";
export { ForwardRef as ReactComponent };